(function () {
  'use strict';

  /* ── 質問データ ──────────────────────────────────────────── */
  // 各質問: { text, a, b, dim }
  // dim: 'EI' | 'SN' | 'TF' | 'JP'
  // A選択 → dim の前の文字、B選択 → dim の後の文字

  var QUESTIONS = [
    // E vs I
    {
      text: 'はじめての場所で、ほっとするのはどちらですか？',
      a: 'まずはその場の空気に入って、人と話してみたい',
      b: '少し様子を見ながら、自分のペースでなじみたい',
      dim: 'EI'
    },
    {
      text: '気持ちが元気になるのは、どちらに近いですか？',
      a: '誰かと話したり、外へ出かけているとき',
      b: 'ひとりでゆっくり、静かに過ごしているとき',
      dim: 'EI'
    },
    {
      text: '人が多い場所にいると、どちらに近いですか？',
      a: '自然と場に馴染んで、楽しめる',
      b: 'にぎやかさを味わったあと、静かな場所で少し整えたくなる',
      dim: 'EI'
    },
    // S vs N
    {
      text: '新しいことをはじめるとき、どちらに近いですか？',
      a: 'まず手順や流れを確かめて、一歩ずつ動く',
      b: 'ざっくりとしたイメージをつかんで、まず動いてみる',
      dim: 'SN'
    },
    {
      text: '日常の中でふと目がいくのは、どちらですか？',
      a: '今ここにある、具体的なことや出来事',
      b: 'これからの可能性や、まだ見えていないもの',
      dim: 'SN'
    },
    {
      text: 'しっくりくるのは、どちらですか？',
      a: '実際に経験したことや、確かな事実',
      b: '言葉になる前の直感や、ふと浮かぶひらめき',
      dim: 'SN'
    },
    // T vs F
    {
      text: '何かを選ぶとき、より大切にしているのはどちらですか？',
      a: '筋道や理由が通っているかどうか',
      b: '気持ちや、まわりの人への影響',
      dim: 'TF'
    },
    {
      text: '大切な人が悩んでいるとき、まずしたいのはどちらですか？',
      a: '解決につながる考えや、具体的な方法を一緒に考える',
      b: 'まず気持ちに寄り添って、じっくり話を聞く',
      dim: 'TF'
    },
    {
      text: '納得できる、と感じやすいのはどちらですか？',
      a: '気持ちを整理して、論理的に考えた結論',
      b: 'その人の状況や気持ちを大切にした判断',
      dim: 'TF'
    },
    // J vs P
    {
      text: 'お出かけや予定の準備は、どちらに近いですか？',
      a: '事前にしっかり計画を立てておくと安心する',
      b: '大まかに決めて、そのときの流れに合わせるのが好き',
      dim: 'JP'
    },
    {
      text: '締め切りや期限があるとき、どちらに近いですか？',
      a: '早めに終わらせて、すっきりしたい',
      b: '期限が近づくほど集中が高まり、流れに乗って仕上げることが多い',
      dim: 'JP'
    },
    {
      text: '気持ちがほどけるのは、どちらに近いですか？',
      a: 'やることが整理されて、先の見通しがある状態',
      b: '余白があって、そのときに合わせて決められる自由がある状態',
      dim: 'JP'
    }
  ];

  /* ── タイプ判定 ──────────────────────────────────────────── */
  // answers: ['A','B','A',...] (12個)
  // 各 dim ごとに A の数が 2以上 → 前の文字、1以下 → 後の文字

  function calcType(answers) {
    var dims = { EI: [0,1,2], SN: [3,4,5], TF: [6,7,8], JP: [9,10,11] };
    var letters = {
      EI: ['E','I'],
      SN: ['S','N'],
      TF: ['T','F'],
      JP: ['J','P']
    };
    var code = '';
    Object.keys(dims).forEach(function (dim) {
      var indices = dims[dim];
      var aCount = indices.filter(function (i) { return answers[i] === 'A'; }).length;
      code += aCount >= 2 ? letters[dim][0] : letters[dim][1];
    });
    return code; // 例: 'INTJ'
  }

  /* ── メイン ──────────────────────────────────────────────── */

  var root = document.querySelector('[data-quiz16]');
  if (!root) return;

  var resultBaseUrl = root.dataset.resultUrl || '/pages/goencha-16types-result';
  var current = 0;
  var answers = [];

  var progressBar   = root.querySelector('[data-quiz16-bar]');
  var progressLabel = root.querySelector('[data-quiz16-progress]');
  var screen        = root.querySelector('[data-quiz16-screen]');

  function updateProgress() {
    var pct = Math.round((current / QUESTIONS.length) * 100);
    if (progressBar)   progressBar.style.width = pct + '%';
    if (progressLabel) progressLabel.textContent = current + ' / ' + QUESTIONS.length;
  }

  function renderQuestion(index) {
    var q = QUESTIONS[index];
    screen.innerHTML =
      '<div class="quiz16__question-wrap">' +
        '<p class="quiz16__q-num">Q.' + String(index + 1).padStart(2, '0') + ' / ' + QUESTIONS.length + '</p>' +
        '<p class="quiz16__q-text">' + q.text + '</p>' +
      '</div>' +
      '<div class="quiz16__choices">' +
        '<button class="quiz16__choice" data-answer="A">' +
          '<span class="quiz16__choice-key">A</span>' +
          '<span>' + q.a + '</span>' +
        '</button>' +
        '<button class="quiz16__choice" data-answer="B">' +
          '<span class="quiz16__choice-key">B</span>' +
          '<span>' + q.b + '</span>' +
        '</button>' +
      '</div>';

    screen.classList.remove('quiz16__screen--exit');
    screen.classList.add('quiz16__screen--enter');
    setTimeout(function () {
      screen.classList.remove('quiz16__screen--enter');
    }, 260);

    screen.querySelectorAll('.quiz16__choice').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var answer = btn.dataset.answer;
        answers[index] = answer;

        btn.classList.add('quiz16__choice--selected');
        btn.disabled = true;
        var other = btn.parentElement.querySelector('.quiz16__choice:not([data-answer="' + answer + '"])');
        if (other) other.disabled = true;

        setTimeout(function () {
          next();
        }, 340);
      });
    });
  }

  function next() {
    screen.classList.add('quiz16__screen--exit');
    setTimeout(function () {
      current++;
      updateProgress();
      if (current >= QUESTIONS.length) {
        finish();
      } else {
        renderQuestion(current);
      }
    }, 210);
  }

  function finish() {
    var typeCode = calcType(answers);
    var typeParam = typeCode.toLowerCase();
    var url = resultBaseUrl + '?t=' + typeParam + '&ogp=20260514b';
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'diag16_quiz_complete', type: typeCode });
    window.location.href = url;
  }

  /* ── 初期化 ──────────────────────────────────────────────── */
  updateProgress();
  renderQuestion(0);
}());
